module.exports = __webpack_public_path__ + "img/british-virgin-islands.c473db2c.png";